import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';

const DefaultValueMap: Record<string, boolean | string | []> = {
  [ConstituentSearchFilterField.NAME_EMAIL_PHONE]: '',
  [ConstituentSearchFilterField.CITY]: '',
  [ConstituentSearchFilterField.STATE]: '',
  [ConstituentSearchFilterField.POSTAL_CODE]: '',
  [ConstituentSearchFilterField.COUNTRY]: [],
  [ConstituentSearchFilterField.USER_IDS]: '',
  [ConstituentSearchFilterField.CONSTITUENT_CATEGORIES]: [],
  [ConstituentSearchFilterField.CONSTITUENT_LABEL_IDS]: [],
  [ConstituentSearchFilterField.BIRTHDAY_MONTH]: '',
  [ConstituentSearchFilterField.DOB]: [],
  [ConstituentSearchFilterField.BOARD_IDS]: [],
  [ConstituentSearchFilterField.COLUMN_IDS]: [],
  [ConstituentSearchFilterField.CONNECTION_EMPLOYER_CONSTITUENT_IDS]: '',
  [ConstituentSearchFilterField.CONNECTION_HOUSEHOLD_CONSTITUENT_IDS]: '',
  [ConstituentSearchFilterField.CONNECTION_CONSTITUENT_IDS]: '',
  [ConstituentSearchFilterField.IS_DECEASED]: true,
  [ConstituentSearchFilterField.DONATION_TYPES]: [],
  [ConstituentSearchFilterField.CAMPAIGN_IDS]: [],
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT]: [],
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT]: [],
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT]: [],
  [ConstituentSearchFilterField.DONATION_AMOUNT]: [],
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_TIME]: [],
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_TIME]: [],
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_TIME]: [],
  [ConstituentSearchFilterField.DONATION_MINUTES]: [],
  [ConstituentSearchFilterField.DONATION_PLAN_CADENCE]: '',
  [ConstituentSearchFilterField.DONATION_DATE]: [],
  [ConstituentSearchFilterField.DONATION_MADE]: true,
  [ConstituentSearchFilterField.DONATION_LABEL_IDS]: [],

  // Custom fields
  [CustomFieldTypes.CHECKBOX]: true,
  [CustomFieldTypes.DATE_PICKER]: [],
  [CustomFieldTypes.LIST_SINGLE]: [],
  [CustomFieldTypes.LIST_MULTI]: [],
  [CustomFieldTypes.TEXT_SINGLE]: '',
  [CustomFieldTypes.TEXT_MULTI]: '',
};

export default DefaultValueMap;
